import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, ArrowRight, Download } from "lucide-react";
import Layout from "../components/Layout";
import Seo from "../seo/Seo";
import { profileGraph } from "../seo/jsonld";
import { candidate, about, program as programMock } from "../mock";

const TITLE = "Ján Kuráň | Kandidát na primátora Ružomberka";
const DESC =
  "Ján Kuráň je Ružomberčan a kandidát na primátora mesta Ružomberok v komunálnych voľbách 2026, volebné číslo 3. Predstavenie kandidáta a jeho vízie pre mesto.";

const AboutPage = () => {
  return (
    <Layout>
      <Seo
        title={TITLE}
        description={DESC}
        path="/o-mne"
        jsonLd={profileGraph({ title: TITLE, description: DESC })}
      />

      <section className="bg-campaign-blue px-4 sm:px-6 py-12 sm:py-16">
        <div className="max-w-4xl mx-auto">
          <nav aria-label="Omrvinková navigácia" className="text-campaign-cream/70 text-sm font-semibold mb-6 flex items-center gap-1">
            <Link to="/" className="hover:text-campaign-yellow">Domov</Link>
            <ChevronRight size={14} />
            <span className="text-campaign-yellow">O mne</span>
          </nav>
          <div className="grid sm:grid-cols-[220px_1fr] gap-8 items-start">
            <img
              src={candidate.photo}
              alt="Ján Kuráň, kandidát na primátora Ružomberka"
              className="w-full max-w-[220px] border-4 border-campaign-ink"
              width="220"
              height="270"
            />
            <div>
              <h1 className="font-display text-4xl sm:text-6xl text-campaign-cream leading-none uppercase">
                Ján Kuráň
              </h1>
              <p className="mt-3 font-semibold text-campaign-yellow text-lg">
                Kandidát na primátora mesta Ružomberok · komunálne voľby 2026 · volebné číslo 3
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-campaign-cream px-4 sm:px-6 py-12 sm:py-16">
        <article className="max-w-3xl mx-auto">
          {about.paragraphs.map((p, i) => (
            <p key={i} className="text-campaign-ink/85 leading-relaxed mb-4 text-lg">{p}</p>
          ))}

          <div className="mt-8 flex flex-wrap gap-4">
            <Link to="/program" className="inline-flex items-center gap-2 bg-campaign-blue text-campaign-cream font-display uppercase text-sm px-5 py-3 border-2 border-campaign-ink shadow-brutal hover-lift">
              Zobraziť celý program <ArrowRight size={18} />
            </Link>
            <a href={programMock.pdfUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-campaign-yellow text-campaign-ink font-display uppercase text-sm px-5 py-3 border-2 border-campaign-ink shadow-brutal hover-lift">
              <Download size={18} /> Program v PDF
            </a>
          </div>
        </article>
      </section>
    </Layout>
  );
};

export default AboutPage;
